// This was taken from the mitt library and modified to suit this project
// https://github.com/developit/mitt

export type Handler<T = unknown> = (event?: T) => void

// A map of event types and their corresponding event handlers.
export type EventHandlerMap = { [name: string]: Handler[] }

export interface EventBus {
  on<T = unknown>(type: string, handler: Handler<T>): void
  off<T = unknown>(type: string, handler?: Handler<T>): void
  emit(type: string, ...args: unknown[]): void
  isEventRegistered(type: string): boolean
  removeAll(): void
}

export default function EventBusInstantiator(): EventBus {
  let events = {} as EventHandlerMap

  return {

    /**
     * Register an event handler for the given type.
     * @param {string} type of event to listen for
     * @param {Function} handler Function to call in response to given event
     */
    on<T = unknown>(type: string, handler: Handler<T>) {
      const handlers = events[type]
      if (!handlers) {
        events[type] = [handler]
        return
      }
      handlers.push(handler)
    },

    /**
     * Remove all or a single event handler for the given type.
     * @param {string} type of event to remove `handler` from
     * @param {Function} handler Handler function to remove. Do not pass to remove all
     */
    off<T = unknown>(type: string, handler?: Handler<T>) {
      if (!handler) {
        delete events[type]
        return
      }
      const handlers = events[type]
      if (handlers) {
        handlers.splice(handlers.indexOf(handler) >>> 0, 1)
      }
    },

    removeAll() {
      events = {}
    },

    /**
     * Invoke all handlers for the given type.
     * @param {string} type of event to invoke
     * @param {unknown} event value
     */
    emit(type: string, ...argsArray: unknown[]) {
      // const argsArray = [].slice.call(arguments, 1)
      ((events[type] || []) as Handler[]).slice().map((handler) => {
        handler.apply(this, argsArray)
      })
    },

    isEventRegistered(type: string) {
      return events[type] ? true : false
    }
  }
}
